import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = ["href"]
const _hoisted_2 = {
  key: 1,
  class: "store store--unavailable",
  "aria-label": "iOS download link is not available"
}
const _hoisted_3 = ["href"]

import { APP_STORE_URL, GOOGLE_PLAY_URL } from "@/content/links";


export default /*@__PURE__*/_defineComponent({
  __name: 'StoreButtons',
  props: {
    tone: { default: "dark" }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["stores", `stores--${__props.tone}`])
  }, [
    (_unref(APP_STORE_URL))
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          class: "store",
          href: _unref(APP_STORE_URL),
          target: "_blank",
          rel: "noopener",
          "aria-label": "Download on the App Store"
        }, [...(_cache[0] || (_cache[0] = [
          _createStaticVNode("<svg class=\"store__icon\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" data-v-fa197784><path fill=\"currentColor\" d=\"M16.37 12.62c-.02-2.35 1.92-3.48 2-3.54-1.09-1.6-2.79-1.82-3.4-1.84-1.45-.15-2.83.85-3.56.85-.74 0-1.87-.83-3.07-.81-1.58.02-3.04.92-3.85 2.34-1.64 2.85-.42 7.07 1.18 9.38.78 1.13 1.71 2.4 2.93 2.36 1.18-.05 1.62-.76 3.04-.76 1.42 0 1.82.76 3.07.74 1.27-.02 2.07-1.15 2.84-2.29.9-1.31 1.27-2.58 1.29-2.65-.03-.01-2.47-.95-2.49-3.78zM14.03 5.72c.65-.79 1.09-1.88.97-2.97-.94.04-2.07.62-2.74 1.41-.6.7-1.13 1.81-.99 2.88 1.05.08 2.12-.53 2.76-1.32z\" data-v-fa197784></path></svg><span class=\"store__text\" data-v-fa197784><span class=\"store__caption\" data-v-fa197784>Download on the</span><span class=\"store__name\" data-v-fa197784>App Store</span></span>", 2)
        ]))], 8, _hoisted_1))
      : (_openBlock(), _createElementBlock("span", _hoisted_2, [...(_cache[1] || (_cache[1] = [
          _createElementVNode("span", { class: "store__text" }, [
            _createElementVNode("span", { class: "store__caption" }, "iOS"),
            _createElementVNode("span", { class: "store__name" }, "Link coming soon")
          ], -1)
        ]))])),
    _createElementVNode("a", {
      class: "store",
      href: _unref(GOOGLE_PLAY_URL),
      target: "_blank",
      rel: "noopener",
      "aria-label": "Get it on Google Play"
    }, [...(_cache[2] || (_cache[2] = [
      _createStaticVNode("<svg class=\"store__icon\" viewBox=\"0 0 24 24\" aria-hidden=\"true\" data-v-fa197784><path fill=\"currentColor\" d=\"M3.61 1.81 13.79 12 3.61 22.19a1.5 1.5 0 0 1-.61-1.21V3.02c0-.49.23-.93.61-1.21zm11.6 8.77 2.63-2.63-11.3-6.52 8.67 9.15zm0 2.84-8.67 9.15 11.3-6.52-2.63-2.63zm4.02-4.66 2.37 1.37c.93.54.93 1.2 0 1.74l-2.37 1.37L16.4 12l2.83-3.24z\" data-v-fa197784></path></svg><span class=\"store__text\" data-v-fa197784><span class=\"store__caption\" data-v-fa197784>Get it on</span><span class=\"store__name\" data-v-fa197784>Google Play</span></span>", 2)
    ]))], 8, _hoisted_3)
  ], 2))
}
}

})